import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostOrdneBesichtigungenCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostOrdneBesichtigungenCommandService],
  exports: []
})
export class PostOrdneBesichtigungenCommandServiceModule { }
